import React from 'react';
import './Banner.css';
import AccountMenu from './AccountMenu';

const Banner = ({ user, handleLogout }) => {

  return (
    <div className="banner">
      <img src="/icons/OptiStudios.jpg" alt="OptiStudios" onClick={() => window.location.href = '/'} style={{ cursor: 'pointer' }} />
      <div className="sign-in-link">
        {user && (
          <AccountMenu user={user} handleLogout={handleLogout} />
        )}
      </div>
    </div>
  );
};

export default Banner;